module.exports = __webpack_public_path__ + "media/newstyle/images/logo-estante-3fd32cff3555801499df1c961b15f800.png";